import { render, staticRenderFns } from "./UpgradePlanBar.vue?vue&type=template&id=388e4398"
import script from "./UpgradePlanBar.vue?vue&type=script&lang=js"
export * from "./UpgradePlanBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports